<template>
    <el-form-item v-bind="formItem" style="width: 100%;">
        <template v-if="formItem.type === 'input'">
            <el-input type="text" v-bind="{ ...formItemAttrs, modelModifiers: { trim: true } }"
                v-on="formItem.vOn || {}" :prefix-icon="Search" :clearable="formItem.attrs?.clearable ?? true"
                @change="debounceInput($event, { formItem, formModel })">
            </el-input>
        </template>
        <template v-else-if="formItem.type === 'select'">
            <el-select style="width: 100%" v-bind="formItemAttrs" v-on="formItem.vOn || {}"
                @change="emit('formChange', { formItem, formModel })"
                :clearable="formItem.attrs?.clearable ?? isShowClearable">
                <el-option :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled"
                    v-for="item in formItem.options"></el-option>
            </el-select>
        </template>
        <template v-else-if="formItem.type === 'radioButton'">
            <el-radio-group style="width: 100%" v-bind="formItemAttrs" v-on="formItem.vOn || {}"
                @change="emit('formChange', { formItem, formModel })">
                <el-radio-button :key="item.label" :label="item.value" v-for="item in formItem.options">{{
                    item.label
                }}</el-radio-button>
            </el-radio-group>
        </template>
        <template v-if="formItem.type === 'datePicker'">
            <el-date-picker
                :disabledDate="formItem?.attrs?.disabledDate || ((time) => disabledDate(time, formItem?.attrs?.monthNumber))"
                v-on="formItem.vOn || {}" v-bind="formItemAttrs" :type="formItem?.attrs?.type || 'daterange'"
                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :clearable="formItem?.attrs?.clearable ?? false"
                @change="emit('formChange', { formItem, formModel })">
            </el-date-picker>
        </template>
        <template v-else-if="formItem.type === 'weekPicker'">
            <el-date-picker :disabledDate="disabledWeek" v-bind="formItemAttrs" v-on="formItem.vOn || {}" type="week"
                format="ww" :clearable="false" @change="emit('formChange', { formItem, formModel })">
            </el-date-picker>
        </template>
        <template v-else-if="!!formItem.customize">
            <slot :name="formItem.fieldName" :item="formItem" :formModel="formModel" />
        </template>
    </el-form-item>
</template>
<script setup>
import { computed, ref, reactive, onBeforeMount, useAttrs } from "vue";
import { debounce } from "lodash-es";
import useSearchForm from "./index.js";
import dayjs from "dayjs";

const props = defineProps({
    formItem: {
        type: Object,
        default: () => { },
    },
});
const emit = defineEmits([
    "formChange"
]);
const attrs = useAttrs();
const formItemAttrs = computed(() => {
    return { ...attrs, ...props.formItem.attrs };
});

const {
    formDataLength,
    disabledDate, disabledHour, disabledMinute, disabledSecond,
    disabledWeek,
    debounceInput,
} = useSearchForm(props, emit);
</script>
<style lang="scss"></style>